import { render, staticRenderFns } from "./RegisterSocialTransformationAgent.vue?vue&type=template&id=6f002fc7&"
import script from "./RegisterSocialTransformationAgent.vue?vue&type=script&lang=js&"
export * from "./RegisterSocialTransformationAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports